module.exports = __webpack_public_path__ + "media/src/application/media/logo-sm-adfb0630f060ed4ba57f54bf14a1f047.svg";